// DS: i6.25
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioPublished: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="m8.11 2.45 2.3 2.28h1.7L8.53 1.18a.6.6 0 0 0-.85 0L4.12 4.73h1.7l2.3-2.28ZM6.91 9.8a1.2 1.2 0 1 0-2.4 0 1.2 1.2 0 0 0 2.4 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 6a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11c.65 0 1-.45 1-1V7c0-.55-.35-1-1-1h-11Zm.6 7.4V7.6h9.8v5.27l-2.78-2.32c-.15-.18-.61-.2-.88-.04-.08.04-3.48 2.87-3.48 2.87l-.03.02H3.1Z"
        />
      </svg>
    </IconWrap>
  );
};
StudioPublished.displayName = 'StudioPublished';

export default StudioPublished;
